import { ErrorHandler, inject, Injectable } from '@angular/core';
import { MonitoringService } from './monitoring.service';

@Injectable()
export class MonitoringErrorHandler implements ErrorHandler {
  private readonly monitoring = inject(MonitoringService);

  handleError(error: unknown): void {
    console.error(error);
    this.monitoring.captureException(error);
  }
}
